'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventAttributeStore = require('./event-attribute-store.js');

var _eventAttributeStore2 = _interopRequireDefault(_eventAttributeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventAggregator = function () {
    function EventAggregator() {
        _classCallCheck(this, EventAggregator);

        this.isInitialized = false;
        this.events = {};
        this.hOP = this.events.hasOwnProperty;
        this.scrollableContainer = null;
    }

    _createClass(EventAggregator, [{
        key: 'subscribe',
        value: function subscribe(eventName, callbackFunction) {
            var _this = this;

            // Create the eventName's object if not yet created
            if (!this.hOP.call(this.events, eventName)) {
                this.events[eventName] = [];
            }

            // Add the listener to queue
            var index = this.events[eventName].push(callbackFunction) - 1;

            // Provide handle back for removal of eventName
            return {
                remove: function remove() {
                    delete _this.events[eventName][index];
                }
            };
        }
    }, {
        key: 'publish',
        value: function publish(eventName, info) {
            // If the eventName doesn't exist, or there's no listeners in queue, just leave
            if (!this.hOP.call(this.events, eventName)) return;

            // Cycle through events queue, fire!
            this.events[eventName].forEach(function (item) {
                item(info !== undefined ? info : {});
            });
        }
    }, {
        key: 'initListeners',
        value: function initListeners(scrollableContainer) {
            var _this2 = this;

            if (typeof window == 'undefined') {
                return;
            }

            if (scrollableContainer) {
                this.initScrollableContainerListeners(scrollableContainer);
            }

            if (!this.isInitialized) {
                this.isInitialized = true;

                window.addEventListener('resize', function (e) {
                    _eventAttributeStore2.default.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    _eventAttributeStore2.default.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                    _this2.publish("onResizeWindowWidth", _eventAttributeStore2.default.windowWidth);
                    _this2.publish("onResizeWindowHeight", _eventAttributeStore2.default.windowHeight);
                });

                window.addEventListener("scroll", function () {
                    _eventAttributeStore2.default.scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
                    _this2.publish("onScroll", _eventAttributeStore2.default.scrollY);
                });

                window.addEventListener('touchmove', function () {
                    var scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

                    if (scrollTop !== _eventAttributeStore2.default.scrollY) {
                        _eventAttributeStore2.default.scrollY = scrollTop;
                        _this2.publish("onScroll", _eventAttributeStore2.default.scrollY);
                    }
                });
            }
        }
    }, {
        key: 'initScrollableContainerListeners',
        value: function initScrollableContainerListeners(container) {
            var _this3 = this;

            var willAddEventListeners = this.scrollableContainer ? false : true;

            if (!this.scrollableContainer || this.scrollableContainer && !this.scrollableContainer.isSameNode(container)) {
                this.scrollableContainer = container;
                willAddEventListeners = true;
            }

            if (willAddEventListeners) {
                this.scrollableContainer.addEventListener("scroll", function () {
                    _eventAttributeStore2.default.overflowScrollY = _this3.scrollableContainer.scrollTop;
                    _this3.publish("overflowOnScroll", _eventAttributeStore2.default.overflowScrollY);
                });

                this.scrollableContainer.addEventListener("touchmove", function () {
                    if (_this3.scrollableContainer.scrollTop !== _eventAttributeStore2.default.overflowScrollY) {
                        _eventAttributeStore2.default.overflowScrollY = _this3.scrollableContainer.scrollTop;
                        _this3.publish("overflowOnScroll", _eventAttributeStore2.default.overflowScrollY);
                    }
                });
            }
        }
    }]);

    return EventAggregator;
}();

var singleton = new EventAggregator();
exports.default = singleton;